<template>
  <div class="el-page-header">
    <div class="el-page-header__left" @click="$emit('back')">
      <i class="el-icon-back"></i>
      <div class="el-page-header__title">
        <slot name="title">{{ title }}</slot>
      </div>
    </div>
    <div class="el-page-header__content">
      <slot name="content">{{ content }}</slot>
    </div>
  </div>
</template>

<script>
import { t } from "element-ui/src/locale";
export default {
  name: "ElPageHeader",
  props: {
    title: {
      type: String,
      default() {
        return '返回';
      },
    },
    content: String,
  },
};
</script>
<style lang="scss" scoped>
.el-page-header {
  margin-top: 10px;
  display: flex;
  line-height: 24px;
  align-items: center;
  margin-left: 10px;
}
.el-page-header__left {
    display: flex;
    cursor: pointer;
    margin-right: 20px;
    position: relative;
     align-items: center;
     .el-icon-back {
       margin-right: 10px;
     }
}
.el-page-header__content {
    font-size: 18px;
    color: #303133;
}
</style>



// WEBPACK FOOTER //
// src/components/pageHeader/src/main.vue